import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';
import productService from 'v2/services/product';

type Payload = {
  productId: number;
  status: number;
};

export function useProductStatusMutation(options: UseMutationOptions<any, unknown, Payload> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ productId, status }: Payload) => productService.changeStatus(productId, status),
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['myProducts'] });
      queryClient.invalidateQueries({ queryKey: ['product'] });
      options.onSuccess?.(...args);
    }
  });
}
